export default {
  title: 'Bankgegevens',
  buttons: {
    save: 'Opslaan',
  },
  toasts: {
    success: 'Uw gegevens zijn succesvol opgeslagen.',
  },
};
